import { render } from "./Polls.vue?vue&type=template&id=1f8de395"
import script from "./Polls.vue?vue&type=script&lang=js"
export * from "./Polls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__